var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$.filter_tab_item },
    [
      _c(
        "div",
        { class: _vm.$.tabs },
        [
          _c("vgp-tabs", {
            attrs: {
              tabs: _vm.preparedTabs,
              active: _vm.activeTab,
              type: "button",
              "gp-autotest-name": "gp_autotest_filter_options_tab",
            },
            on: { onToggle: _vm.toggleTab },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("filter-item", {
        attrs: { "filter-item": _vm.currentItem, readonly: false },
        on: {
          changeFilter: function (data) {
            return _vm.changeFilter(data)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }